<template>
  <v-card
    class="card-base app-online-card"
    :class="{ 'app-online-card--blue': slide }"
  >
    <img src="@/assets/img/eis.png" class="eis-logo-grey" alt="" />
    <div class="d-flex flex-column w-100">
      <div>
        <div
          class="text-big-size app-online-card__title"
          :class="{ 'app-online-card__title--black': slide }"
        >
          Запись к нотариусу онлайн
        </div>
        <div
          class="text-small-size app-online-card__text"
          :class="{ 'app-online-card__text--black': slide }"
        >
          Вы можете записаться на прием к нотариусу через портал
        </div>
      </div>

      <div class="pt-8 mt-auto">
        <v-btn
          v-if="!slide"
          depressed
          color="primary"
          class="button-base app-online-card__button"
          disabled
        >
          Записаться
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'AppointmentOnlineCard',
  props: ['slide'],
};
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}

.app-online-card {
  display: flex;
  height: 260px;
  padding-left: 82px;
  padding-top: 42px;
  padding-bottom: 32px;
  position: relative;
  overflow: hidden;

  &--blue {
    background: $color-base;
    padding-left: 20px;
  }

  &__title {
    width: 50%;
    margin-bottom: 12px;
    color: $color-base;
  }

  &__text {
    color: $color-base;
    width: 32%;
    line-height: 15px;
  }

  & &__img {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
  }
}

.app-online-card--blue {
  padding-left: 20px;
  & .app-online-card__title,
  & .app-online-card__text,
  & .app-online-card__img {
    color: white;
    width: 70%;
  }
}

.eis-logo-grey {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);

  position: absolute;
  height: 100%;
  right: 28px;
  top: 0;
  opacity: 0.1;
  transform: scale(1.5);
}
.content {
  position: relative;
}
</style>
